/* NovaBreak Card Inspector — opens only from an explicit inspect button.
   Zoom uses the visible +/- controls, keyboard, or mouse wheel. Dragging pans
   an already zoomed image. No pinch, double-tap, or hover-triggered opening. */
(function () {
  'use strict';
  if (window.NB && window.NB.Inspect) return;

  var HARD_MAX = 5;
  var maxS = HARD_MAX; /* per-image: capped at the source's sharpness limit */
  var ui = null, img = null, stage = null, faces = [], faceIdx = 0, lastFocus = null;
  var s = 1, tx = 0, ty = 0;
  var drag = null, hinted = false, oldHtmlOverflow = '', oldBodyOverflow = '';

  function hiRes(url) {
    if (!url) return url;
    /* normalize any existing width param to 2048 */
    url = String(url).replace(/([?&])width=\d+/, '$1width=2048');
    if (!/width=/.test(url)) url += (url.indexOf('?') >= 0 ? '&' : '?') + 'width=2048';
    return url;
  }
  function esc(v) { return (window.NB && NB.esc) ? NB.esc(v) : String(v == null ? '' : v); }

  function build() {
    if (ui) return;
    ui = document.createElement('div');
    ui.className = 'nb-inspect';
    ui.setAttribute('role', 'dialog');
    ui.setAttribute('aria-modal', 'true');
    ui.setAttribute('aria-label', 'Card inspector');
    ui.hidden = true;
    ui.innerHTML =
      '<div class="nb-inspect__bar">' +
        '<div class="nb-inspect__faces" data-ci-faces></div>' +
        '<button type="button" class="nb-inspect__close" data-ci-close aria-label="Close inspector">&times;</button>' +
      '</div>' +
      '<div class="nb-inspect__stage" data-ci-stage>' +
        '<img data-ci-img alt="" draggable="false">' +
      '</div>' +
      '<div class="nb-inspect__foot">' +
        '<button type="button" class="nb-inspect__zbtn" data-ci-out aria-label="Zoom out">&minus;</button>' +
        '<span class="nb-inspect__hint" data-ci-hint>Use + and −, then drag to inspect</span>' +
        '<button type="button" class="nb-inspect__zbtn" data-ci-in aria-label="Zoom in">+</button>' +
      '</div>';
    document.body.appendChild(ui);
    img = ui.querySelector('[data-ci-img]');
    stage = ui.querySelector('[data-ci-stage]');

    ui.querySelector('[data-ci-close]').addEventListener('click', close);
    ui.addEventListener('click', function (e) { if (e.target === ui || e.target === stage) { if (s <= 1.02) close(); } });
    ui.querySelector('[data-ci-in]').addEventListener('click', function () { zoomAt(centerPoint(), Math.min(maxS, s * 1.5)); });
    ui.querySelector('[data-ci-out]').addEventListener('click', function () { zoomAt(centerPoint(), Math.max(1, s / 1.5)); });
    document.addEventListener('keydown', function (e) {
      if (ui.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === '+' || e.key === '=') zoomAt(centerPoint(), Math.min(maxS, s * 1.4));
      if (e.key === '-') zoomAt(centerPoint(), Math.max(1, s / 1.4));
    });

    stage.addEventListener('pointerdown', onDown);
    stage.addEventListener('pointermove', onMove);
    stage.addEventListener('pointerup', onUp);
    stage.addEventListener('pointercancel', onUp);
    stage.addEventListener('wheel', onWheel, { passive: false });
    img.addEventListener('load', function () {
      ui.classList.remove('is-loading');
      /* Sharpness ceiling: the scale where 1 source pixel ~ 1 device pixel,
         plus a little grace. Zooming past this only magnifies blur, which
         reads as damage/poor quality on a card. */
      var dpr = window.devicePixelRatio || 1;
      var base = img.offsetWidth || 1;
      var trueMax = img.naturalWidth / (base * dpr);
      maxS = Math.max(2.2, Math.min(HARD_MAX, trueMax * 1.3));
    });
  }

  /* ---------- geometry ---------- */
  function centerPoint() { var r = stage.getBoundingClientRect(); return { x: r.left + r.width / 2, y: r.top + r.height / 2 }; }
  function pt(e) { return { x: e.clientX, y: e.clientY }; }
  function apply() {
    clampPan();
    img.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + s + ')';
    ui.classList.toggle('is-zoomed', s > 1.02);
  }
  function clampPan() {
    var sr = stage.getBoundingClientRect();
    var iw = img.offsetWidth * s, ih = img.offsetHeight * s;
    var mx = Math.max(0, (iw - sr.width) / 2), my = Math.max(0, (ih - sr.height) / 2);
    tx = Math.min(mx, Math.max(-mx, tx));
    ty = Math.min(my, Math.max(-my, ty));
  }
  /* Zoom so the screen point p stays anchored: t' = p' - (p' - t) * (s'/s) with p' relative to stage center. */
  function zoomAt(p, ns) {
    var c = centerPoint();
    var px = p.x - c.x, py = p.y - c.y;
    var k = ns / s;
    tx = px - (px - tx) * k;
    ty = py - (py - ty) * k;
    s = ns;
    if (s <= 1.02) { s = 1; tx = 0; ty = 0; }
    apply(); dismissHint();
  }
  function dismissHint() {
    if (hinted) return; hinted = true;
    var h = ui.querySelector('[data-ci-hint]');
    if (h) h.classList.add('is-done');
  }

  /* ---------- pan an already zoomed image ---------- */
  function onDown(e) {
    if (s <= 1.02) return;
    stage.setPointerCapture && stage.setPointerCapture(e.pointerId);
    drag = { id: e.pointerId, x: e.clientX, y: e.clientY };
    e.preventDefault();
  }
  function onMove(e) {
    if (!drag || drag.id !== e.pointerId) return;
    tx += e.clientX - drag.x;
    ty += e.clientY - drag.y;
    drag.x = e.clientX;
    drag.y = e.clientY;
    apply();
    e.preventDefault();
  }
  function onUp(e) {
    if (drag && drag.id === e.pointerId) drag = null;
  }
  function onWheel(e) {
    e.preventDefault();
    var ns = Math.min(maxS, Math.max(1, s * (e.deltaY < 0 ? 1.14 : 0.88)));
    zoomAt(pt(e), ns);
  }

  /* ---------- faces ---------- */
  function renderFaces() {
    var host = ui.querySelector('[data-ci-faces]');
    if (faces.length < 2) { host.innerHTML = '<span class="nb-inspect__label">' + esc(faces[0] && faces[0].label || '') + '</span>'; return; }
    host.innerHTML = faces.map(function (f, i) {
      return '<button type="button" class="nb-inspect__face' + (i === faceIdx ? ' is-on' : '') + '" data-ci-face="' + i + '">' + esc(f.label || ('View ' + (i + 1))) + '</button>';
    }).join('');
    host.querySelectorAll('[data-ci-face]').forEach(function (b) {
      b.addEventListener('click', function () { setFace(parseInt(b.dataset.ciFace, 10)); });
    });
  }
  function setFace(i) {
    if (!faces[i]) return;
    faceIdx = i;
    s = 1; tx = 0; ty = 0; apply();
    ui.classList.add('is-loading');
    img.src = hiRes(faces[i].src);
    img.alt = faces[i].label || '';
    renderFaces();
  }

  /* ---------- open / close ---------- */
  function open(list, start) {
    faces = (list || []).filter(function (f) { return f && f.src; });
    if (!faces.length) return;
    build();
    lastFocus = document.activeElement;
    ui.hidden = false;
    oldHtmlOverflow = document.documentElement.style.overflow;
    oldBodyOverflow = document.body.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    setFace(Math.min(start || 0, faces.length - 1));
    var c = ui.querySelector('[data-ci-close]');
    if (c) c.focus();
    if (window.NB && NB.announce) NB.announce('Card inspector opened. Use plus and minus to zoom, then drag to inspect.');
  }
  function close() {
    if (!ui || ui.hidden) return;
    ui.hidden = true;
    document.documentElement.style.overflow = oldHtmlOverflow;
    document.body.style.overflow = oldBodyOverflow;
    s = 1; tx = 0; ty = 0; drag = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- auto-binding ---------- */
  /* Whichever side of the card is showing is the side that opens (QA #3).
     Card3D flips the .nb-card element itself, so a negative X basis in its
     transform matrix means the back is up. */
  function visibleFace(btn) {
    var scope = btn.closest && btn.closest('.nb-product__media, .nb-qvimg, .nb-spotlight__card');
    var card = scope && scope.querySelector('.nb-card');
    if (!card) return 0;
    var t = getComputedStyle(card).transform;
    if (t && t !== 'none') {
      var m = t.match(/matrix(?:3d)?\(([^)]+)\)/);
      if (m && parseFloat(m[1].split(',')[0]) < 0) return 1;
    }
    return 0;
  }
  /* Buttons: <button data-nb-inspect data-faces='[{"src":"...","label":"Front"}]'> */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-nb-inspect]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation(); /* never also trigger the pocket / link underneath */
    var list = [];
    try { list = JSON.parse(b.getAttribute('data-faces') || '[]'); } catch (err) {}
    open(list, Math.min(visibleFace(b), Math.max(0, list.length - 1)));
  });
  window.NB = window.NB || {};
  NB.Inspect = { open: open, close: close, hiRes: hiRes };
})();
